<!-- <a (click)="openMaps()">{{'title.show-on-map' | translate}} <i class="fas fa-map-marker fa-1x" aria-hidden="true"></i></a> -->


<button class="btn btn-outline-primary btn-sm btn-icon-only" (click)="openMaps()" triggers="mouseenter:mouseleave" placement="top" container="body" [ngbPopover]="'title.show-on-map'| translate">
  <i class="fas fa-map-marker" aria-hidden="true"></i>
</button>